import { render } from "./readCardOrderSetup.vue?vue&type=template&id=08bc8754"
import script from "./readCardOrderSetup.vue?vue&type=script&lang=js"
export * from "./readCardOrderSetup.vue?vue&type=script&lang=js"

import "./readCardOrderSetup.vue?vue&type=style&index=0&id=08bc8754&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__